import React from 'react';
import { useSelector } from 'react-redux';
import { sanitize } from '../../../../../common/services/sanitizeService';

import { getDivestitureDiagnosticResults } from '../../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';

const AdditionalCommentsView = () => {
  const { comment } = useSelector(getDivestitureDiagnosticResults);
  const noCommentVerbiage = 'No additional comments entered.';
  const commentOrDefault = comment || noCommentVerbiage;

  return (
    <div className="response-section-container">
      <table>
        <thead>
          <tr>
            <th>Additional Comments</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div
                className="additional-comments-rich-text"
                dangerouslySetInnerHTML={{ __html: sanitize(commentOrDefault) }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AdditionalCommentsView;
